import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { StudentPracticeSession } from '@ts-core/modules/practice/types';
import {
  getStudentPracticeSessionsQuery,
  GetStudentPracticeSessionsQueryResult,
  GetStudentPracticeSessionsQueryVariables,
} from '../graphql/queries/getStudentPracticeSessionsQuery';

type StudentPracticeSessionsHookResult = DataFetcherHookResult<StudentPracticeSession[], 'studentPracticeSessions'>;

interface StudentPracticeSessionsHookInput {
  courseId: string;
  studentId: string;
}

export default function useStudentPracticeSessions(input: StudentPracticeSessionsHookInput): StudentPracticeSessionsHookResult {
  const { courseId, studentId } = input;
  const { data, loading, error } = useQuery<GetStudentPracticeSessionsQueryResult, GetStudentPracticeSessionsQueryVariables>(
    getStudentPracticeSessionsQuery,
    { variables: { courseId, studentId } }
  );

  return { loading, error: getErrorMessage({ error }), studentPracticeSessions: data?.studentPracticeSessions };
}
